import { apolloProvider } from '@/modules/myStageGraphQL';
import { EDIT_CHAT_MESSAGE } from '@/graphql/chatHistory';

import logger from '@/modules/Logger';

export const UpdateChatMessageService = {
  msb: async (params, callback) => {
    logger.info(`[Chat Update] Update chat message from MSB endpoint`, {
      operation: 'chat-history:update'
    });

    const client = apolloProvider.defaultClient;
    const payload = {
      student_book_id: parseInt(params.lessonId),
      message_id: parseInt(params.messageId),
      message: params.message
    };

    try {
      const { data } = await client.mutate({
        mutation: EDIT_CHAT_MESSAGE,
        fetchPolicy: 'no-cache',
        variables: payload
      });

      if (data?.editChatMessage) {
        callback(data?.editChatMessage);
      } else {
        logger.error(`[Chat Update] Empty result from update of MSB GraphQL API`, {
          operation: 'chat-history:update',
          event_type: 4,
          payload: payload
        });
      }
    } catch (error) {
      logger.error(`[Chat Update] Error updating chat data`, {
        error: error.message,
        operation: 'chat-history:update'
      });
      callback(null);
    }

    return true;
  },

  legacy: async (params, callback) => {
    logger.info(`[Chat Update] Update chat message from LEGACY endpoint - skipped`, {
      operation: 'chat-history:update',
      payload: {
        params, callback
      }
    });

    callback(null);
    
    return false;
  }
};
